export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9371.31691e47.jpg";